/**
 * @generated SignedSource<<3505b08f2780f67b406db1becb58e301>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetWeatherCondition = "BROKEN_CLOUDS" | "CLEAR_SKY" | "FEW_CLOUDS" | "MIST" | "RAIN" | "SCATTERED_CLOUDS" | "SHOWER_RAIN" | "SNOW" | "THUNDERSTORM";
import { FragmentRefs } from "relay-runtime";
export type WidgetWeatherDatePaneListItem_WeatherOccasion$data = {
  readonly condition: WidgetWeatherCondition;
  readonly date: string;
  readonly highTemp: number;
  readonly lowTemp: number;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherConditionIcon_WeatherOccasion">;
  readonly " $fragmentType": "WidgetWeatherDatePaneListItem_WeatherOccasion";
};
export type WidgetWeatherDatePaneListItem_WeatherOccasion$key = {
  readonly " $data"?: WidgetWeatherDatePaneListItem_WeatherOccasion$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetWeatherDatePaneListItem_WeatherOccasion">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetWeatherDatePaneListItem_WeatherOccasion",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "date",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "condition",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lowTemp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "highTemp",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetWeatherConditionIcon_WeatherOccasion"
    }
  ],
  "type": "WidgetWeatherOccasion",
  "abstractKey": null
};

(node as any).hash = "c2f821c6c7c371598677672ba059f3a2";

export default node;
